import { Children, isValidElement } from "react";

import { TableItem as Container } from "./styles";

/**
 * Texto puro de um nó React, para usar como tooltip. Só desce por elementos
 * simples; se a célula tiver um componente de verdade dentro (badge, botão),
 * devolve vazio e nenhum title é posto.
 */
function textoDe(node) {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(textoDe).join("");
  if (isValidElement(node)) return Children.toArray(node.props?.children).map(textoDe).join("");
  return "";
}

/**
 * A célula tem componente dentro (menu de ações, badge, link) ou é só texto?
 *
 * Importa porque o recorte com reticências exige `overflow: hidden`, e isso
 * CORTA qualquer coisa que precise sair da célula. Foi o que aconteceu com o
 * menu dos três pontinhos em Pacotes disponíveis: ele abria com Editar,
 * Vender e Inativar, mas o span de truncagem terminava 1px acima do menu e
 * escondia os três. A loja simplesmente não conseguia vender pacote.
 *
 * Texto continua truncando; componente passa direto, sem recorte.
 */
function temComponente(children) {
  return Children.toArray(children).some((filho) => isValidElement(filho));
}

export function TableItem({ children, title, ...rest }) {
  const componente = temComponente(children);

  if (componente) {
    return (
      <Container {...rest} data-livre="true" title={title}>
        {children}
      </Container>
    );
  }

  // nome comprido é cortado com reticências; o title devolve o valor inteiro
  // ao passar o mouse. Um title explícito tem prioridade.
  const tooltip = title ?? (textoDe(children).trim() || undefined);

  return (
    <Container {...rest}>
      <span title={tooltip}>{children}</span>
    </Container>
  );
}
